import * as React from "react";
import "@aurodesignsystem/auro-input";
import "@aurodesignsystem/auro-select";
import "@aurodesignsystem/auro-menu";
import "@aurodesignsystem/auro-combobox";
import { useHistory } from "react-router-dom";
import { EventType, EventTypeInput } from "../../Models/EventType";
import { useEffect } from "react";
import EditEventTypeInput from "./EditEventTypeInput";
import { EventTypeProvider } from "../../providers/EventTypeProvider";
import {useAuthentication} from "meportal/AuthenticationProvider";
import { updateEventType, eventTypeHasActiveEvent } from "../../services/otsEventService";
import { editEventTypePermissions, EventTypeAssignmentsRequest, Group, Permission }from "meportal/AuthorizationProvider";
import DeactivateEventTypeModal from "../Modal/DeactivateEventTypeModal";
import DeactivateEventTypeErrorModal from "../Modal/DeactivateEventTypeErrorModal";


interface EventTypeModalProps {
  contextPath: any;
  eventType: EventType | undefined;
  refreshDashboard: any; 
}
const Overlay = () => {
  return (
      <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(245, 246, 248, 0.5)',
          zIndex: 2,
      }}></div>
  );
}

export default function EditEventType(props: EventTypeModalProps) {
  const { contextPath, eventType } =
    props;
  const history = useHistory();
  const { userData, getLatestAccessToken } = useAuthentication();
  const [isSubmitDisabled, setIsSubmitDisabled] = React.useState(false);
  const [loading, setLoader] = React.useState(true);
  const [status, setStatus] = React.useState("");
  const [editedEventType, setEditedEventType] = React.useState<EventType>();
  const [showDeactivateModal, setShowDeactivateModal] = React.useState(false);
  const [showDeactivateErrorModal, setShowDeactivateErrorModal] = React.useState(false);
  const [groupAssignments, setGroupAssignments] = React.useState<Group[]>();
  const [editMessage, setEditMessage] = React.useState<any>();
  const [reasonForActiveChanged, setReasonForActiveChanged] = React.useState("");
  const [isValidComment, setIsValidComment] = React.useState(false);
  const [isLocked, setIsLocked] = React.useState(false);

useEffect(() => {
  if (eventType === undefined) return;
  setEditedEventType(eventType);
  setLoader(false);
  
});

useEffect(() => {
  setIsLocked(editedEventType?.IsLocked || false);
}, [editedEventType?.IsLocked]);

  const handleMessageDataChange = (messageData: any) => {
    setEditMessage(messageData);
    setReasonForActiveChanged(messageData.comment);
    setIsValidComment(messageData.isValidComment);
};
const handleDeactivateClick = () => {
  // validate there are no open events for the event type being deactivated 
  eventTypeHasActiveEvent(userData, eventType?.Name ?? "").then((hasActiveEvent) => {
    if (hasActiveEvent.HasActiveOpenEvents) {
       // alert("Cannot deactivate event type with active events.");
       setShowDeactivateErrorModal(true);
    } else {
      setShowDeactivateModal(true);
    }
  });
  //setShowDeactivateModal(true);
}
const handleModalClose = () => { 
  setShowDeactivateModal(false);  
}
const handleErrorModalClose = () => { 
  setShowDeactivateErrorModal(false);  
}
const deactivateEventType = () =>  {
    console.log("Deactivate event type"); 
    let request = editEventTypeRequest();
    request.IsActive = !request.IsActive;
    getLatestAccessToken().then((token) => {
      userData.access_token = token;
      updateEventType(userData, request).then((statusCode) => {
        console.log("statusCode update event type: ", statusCode);
        if (statusCode === 200 || statusCode.status) {
          setStatus("success");
          setTimeout(() => {
            setStatus("");
            props.refreshDashboard();

          }, 1000);
        } else { 
          setStatus("error");
          setTimeout(() => {
            setStatus("");
          }, 1000);
        }
      });
    });

    setStatus("success");
    history.push(contextPath);
}

const handlePostClick = () => {
    setStatus("loading");
    console.log("Post event type updates", groupAssignments);
    if(groupAssignments === undefined) {
      setStatus("");
      return;
    };
    let request = createEventTypePermissionsRequest(groupAssignments);
    let eventTypeRequest = editEventTypeRequest();
    getLatestAccessToken().then((token) => {
      userData.access_token = token;
      updateEventType(userData, eventTypeRequest).then((statusCode) => {
          console.log("statusCode update event type: ", statusCode);
          if (statusCode === 200 || statusCode.status) {
            editEventTypePermissions(userData, request)
              .then((statusCode) => {
                if (statusCode === 200 || statusCode.status) {
                  setStatus("success");
                  setTimeout(() => {
                    setStatus("");
                    props.refreshDashboard();
                    history.push(contextPath);
                  }, 1000);
                } else {
                  setStatus("error");
                  setTimeout(() => {
                    setStatus("");
                  }, 1000);
                }
            });
          } else { 
            setStatus("error");
            setTimeout(() => {
              setStatus("");
            }, 1000);
          }
        });
    });
    setStatus("success");
  };

  const createEventTypePermissionsRequest = (groupAssignments: Group[]) => { 
    let groupsToAdd: Group[] = [];

    groupAssignments.forEach((group: Group) => {
        let groupToAdd: Group = {
            id: group.id,
            Name: group.Name,
            Permissions: group.Permissions.filter((perm: Permission) => perm.checked),
        };
        groupToAdd.Permissions.map((perm: Permission) => { perm.IsActive = true});
        groupsToAdd.push(groupToAdd);
    });
    let request: EventTypeAssignmentsRequest = {
        id: eventType?.Id,
        isLocked: isLocked,
        eventTypeId: userData.profile.company + ":" + eventType?.Name.trim(),
        groups: groupsToAdd,
        lastUpdatedBy: userData.profile.given_name + " " + userData.profile.family_name,
        updateReason: editMessage,
    };
    return request;
}
const editEventTypeRequest = () => {
    let input = editedEventType!;
    console.log("Edited Event Type: ", input);
    let request: EventTypeInput = {
        Airline: input.Airline,
        Id: input.Id,
        Name: input.Name,
        ReasonForEventType: input.Reason,
        Category: input.Category,
        CreatedBy: input.CreatedBy,
        CreatedDateTimeUTC: input.CreatedDateTimeUTC,
        IsActive: input.IsActive,
        IsLocked: isLocked,
        ReasonForActiveChanged: reasonForActiveChanged,
        LastUpdatedBy: userData.profile.given_name + " " + userData.profile.family_name,
        LastUpdatedDateTimeUTC: "",
        IsSubmitDisabled: isSubmitDisabled,
    };
    console.log("Formatted request:", request);
    return request;
}

  const handleEditDataChange = (editedData: any) => {

    if (editedEventType === undefined) return;
    // editedEventType!.IsActive = editedData.IsActive;
    console.log("edited data callback: ", editedData);
    setIsLocked(editedData.isLocked);
    setEditedEventType(prevState => ({
      ...prevState!,
      Id: prevState?.Id || '',
      IsActive: editedData.isActive,
    }));
  };
  const handleGroupAssignments = (groups: Group[]) => {
    console.log("Edited group permissions callback in EDITEVENTTYPE.TSX", groups);
    setGroupAssignments(groups);
}


  return (
    <React.Fragment>
    {status !== "" && <Overlay />}
    <div className="input-form-container">
      <EventTypeProvider eventTypeName={""}>
        <EditEventTypeInput
                    onEditEventType={eventType}
                    onEditDataChange={handleEditDataChange}
                    handleGroupAssignments={handleGroupAssignments}

        > 
        </EditEventTypeInput> 
      </EventTypeProvider>
      <footer className="create-event-type-footer">
                  {status === "loading" && (
                    <button className="loading-button">
                      <h2 className="alert-text">Loading...</h2>
                    </button>
                  )}
                  {status === "success" && (
                    <button className="success-button">
                      <h2 className="alert-text">
                          Event type updated successfully!
                      </h2>
                    </button>
                  )}
                  {status === "error" && (
                    <button className="error-button">
                      <h2 className="alert-text">
                          "Event update failed. Try again!"
                      </h2>
                    </button>
                  )}
                  {status === "" && (
                    <>
                    <div className="footer-buttons-container-edit">
                      <div className="footer-button footer-button-deactivate" >
                            <div className="button-wrapper-modal">
                                {!eventType?.IsForAirborne && <auro-button
                                  class={eventType?.IsActive ? "auro-button-deactivate" : "auro-button-activate"}
                                  variant="secondary"
                                  fluid
                                  onClick={handleDeactivateClick}
                                >
                                  <span className={`btnlabel-blue modal-button ${eventType?.IsActive ? "btnlabel-deactivate" : "btnlabel-activate"}`}>
                                    {eventType?.IsActive ? "Deactivate" : "Activate"}
                                  </span>
                                </auro-button> }

                                {eventType?.IsForAirborne && <auro-button
                                  class="disabled"
                                  variant="secondary"
                                  disabled
                                  fluid
                                  onClick={handleDeactivateClick}
                                >
                                  <span className={`btnlabel-grey modal-button btnlabel-system-event-type`}>
                                    Deactivate
                                  </span>
                                </auro-button> }
                            </div>
                      </div>
                      <div className="footer-button" style={{ marginLeft: 'auto' }}>
                            <div className="button-wrapper-modal">
                                <auro-button
                                  variant="secondary"
                                  fluid
                                  onClick={() => {history.push(contextPath)}}
                                >
                                  <span className="btnlabel-blue modal-button">
                                    Cancel
                                  </span>
                                </auro-button>
                            </div>
                      </div>
                      <div className="footer-button footer-button-post-edit-event-type">
                        <div className="button-wrapper-modal">
                          <auro-button
                            variant="primary"
                            fluid
                            onClick={handlePostClick}
                            class={
                              isSubmitDisabled 
                                ? "disabled"
                                : ""
                            }
                          >
                            <span className="btnlabel-white modal-button">
                              Save
                            </span>
                          </auro-button>
                        </div>
                      </div>
                    </div>
                    </>
                  )}
                </footer>
          
    </div>
    <DeactivateEventTypeModal eventName={eventType ? eventType.Name : "" } isActive={eventType ? eventType.IsActive : false} isModalOpen={showDeactivateModal} isValidComment={isValidComment} close={handleModalClose} confirm={deactivateEventType} messageChange={handleMessageDataChange} />
    <DeactivateEventTypeErrorModal eventName={eventType ? eventType.Name : "" } isModalOpen={showDeactivateErrorModal} close={handleErrorModalClose} />
    
    </React.Fragment>
  );
}
